import { BREAKPOINTS } from "./breakpoints";
import resolveStylePropValue from "./resolveStylePropValue";
export default function resolveResponsiveStyleProp(props) {
    const { value, config, tokens, getToken } = props;
    if (value === null)
        return {};
    const { property } = config;
    const vars = {};
    for (const bp of BREAKPOINTS) {
        if (value[bp] === undefined)
            continue;
        const resolved = resolveStylePropValue({
            value: value[bp],
            config,
            tokens,
            getToken,
        });
        if (resolved === undefined)
            continue;
        // The smallest breakpoint given also applies below it
        if (!(property in vars))
            vars[property] = resolved;
        vars[`${property}-${bp}`] = resolved;
    }
    return vars;
}
//# sourceMappingURL=resolveResponsiveStyleProp.js.map